import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 'urn:linced:meta:admin', label: 'LINCED_ADMIN' },
    { value: 'urn:linced:meta:manager', label: 'LINCED_MANAGER' },
    { value: 'urn:linced:organisation:role:admin', label: 'TENANT_ADMIN' },
    { value: 'urn:linced:organisation:role:staff', label: 'TENANT_STAFF' },
    { value: 'urn:linced:organisation:role:caregiver', label: 'CAREGIVER' },
    { value: 'urn:linced:organisation:role:learner', label: 'LEARNER' },
  ],
});
